import type { CreateNotification201BasicInfo } from './createNotification201BasicInfo';
import type { CreateNotification201Data } from './createNotification201Data';
import type { CreateNotification201Source } from './createNotification201Source';
import type { CreateNotification201Status } from './createNotification201Status';
import type { CreateNotification201Target } from './createNotification201Target';

export type CreateNotification201 = {
  basicInfo: CreateNotification201BasicInfo;
  /** @nullable */
  data?: CreateNotification201Data;
  source?: CreateNotification201Source;
  status: CreateNotification201Status;
  target?: CreateNotification201Target;
};
